<div class="form-container">
  @if (config.titulo) {
  <div class="tituloPantalla">
    <div class="a-titulo">{{ config.titulo }}</div>
  </div>
  }

  <form [formGroup]="group" autocomplete="off">
    <div class="a-example-full-width-alterno-content">
      <p-accordion [multiple]="true">
        <p-accordionTab header="Correo" [selected]="true">

          @if(config.filtrosBusquedaHistorica){
          <!-- 1. SECCIÓN DE BÚSQUEDA DESTACADA AL INICIO -->
          <div class="search-container" style="background-color: #f8f9fa; padding: 15px; border-radius: 8px; margin-bottom: 20px; border: 1px solid #e9ecef;">
            <label for="asunto_orig" style="font-weight: 600; color: #495057; display: block; margin-bottom: 8px;">
              <i class="pi pi-history" style="margin-right: 5px;"></i> Buscar e importar correo histórico
            </label>
            <div class="p-inputgroup" style="width: 100%; display: flex;">
              <input pInputText type="text" formControlName="asunto_orig" id="asunto_orig"
                placeholder="Ingrese el asunto a buscar..." 
                style="flex: 1; min-width: 0; width: 100%;">
              <button type="button" pButton icon="pi pi-search" class="p-button-primary p-button-sm"
                (click)="searchCorreoHistorico()">
              </button>
            </div>
          </div>

          <!-- SEPARADOR VISUAL -->
          <div style="border-bottom: 1px solid #dee2e6; margin-bottom: 20px;"></div>
          }

          <!-- 2. CAMPOS DEL CORREO -->
          <div class="form-group" style="margin-bottom: 15px;">
            <label for="mailFrom" style="font-weight: 500;">De</label>
            <input pInputText type="text" formControlName="mailFrom" id="mailFrom" placeholder=" "
              class="p-inputtext-sm" [disabled]="true" style="width: 100%;">
          </div>

          <div class="form-group" style="margin-bottom: 15px;">
            <label for="mailTo" style="font-weight: 500;">Para</label>
            <input pInputText type="text" formControlName="mailTo" id="mailTo" placeholder=" " class="p-inputtext-sm"
              style="width: 100%;">
          </div>

          <div class="form-group" style="margin-bottom: 15px;">
            <label for="mailCc" style="font-weight: 500;">CC</label>
            <input pInputText type="text" formControlName="mailCc" id="mailCc" placeholder=" " class="p-inputtext-sm"
              style="width: 100%;">
          </div>
          <div class="form-group" style="margin-bottom: 15px;">
            <label for="mailBcc" style="font-weight: 500;">CCO</label>
            <input pInputText type="text" formControlName="mailBcc" id="mailBcc" placeholder=" " class="p-inputtext-sm"
              style="width: 100%;">
          </div>

          <div class="form-group" style="margin-bottom: 15px;">
            <label for="subject" style="font-weight: 500;">Asunto</label>
            <input pInputText type="text" formControlName="subject" id="subject" placeholder=" " class="p-inputtext-sm"
              style="width: 100%;">
          </div>

        </p-accordionTab>

        @if(config.mostrarArchivosAdjuntos){
        <p-accordionTab header="Archivos Adjuntos">
          <div class="a-example-full-width-alterno-content">
            <p-fileUpload #fileUpload name="demo[]" [customUpload]="true" (uploadHandler)="onUpload($event, fileUpload)"
              [multiple]="true" [maxFileSize]="1000000" [disabled]="config.modoLectura">
              <ng-template pTemplate="content">
                @if (uploadedFiles.length) {
                <ul>
                  @for (file of uploadedFiles; track file.item1) {
                  <li>
                    <div class="a-example-full-width-alterno-content-row"
                      style="justify-content: space-between; margin-bottom: 1%;">
                      <div class="a-example-full-width-alterno-content-0_2 label">
                        {{ file.item1 }} <strong>-</strong> {{ file.item3 }}
                      </div>
                      <div class="a-example-full-width-alterno-content-6">
                        <p-button icon="pi pi-download" class="p-button-secondary"
                          (onClick)="downloadFile(file)"></p-button>
                      </div>
                    </div>
                  </li>
                  }
                </ul>
                } @else {
                <div style="padding: 10px; color: #888;">
                  No hay archivos adjuntos.
                </div>
                }
              </ng-template>
            </p-fileUpload>
          </div>
        </p-accordionTab>
        }
      </p-accordion>
    </div>

    <!-- Editor según modo -->
    <div class="a-example-full-width-alterno-content" style="margin-top: 2%">
      @if (!config.modoLectura) {
      <smart-editor #smartEditor id="smartEditor" auto-save [toolbarItems]="toolbarItems" style="width: auto;">
      </smart-editor>
      } @else {
      <div [innerHTML]="group.get('correo')?.value"
        style="border: 1px solid #ccc; padding: 12px; min-height: 320px; overflow-y: auto; background: #fff; border-radius: 4px;">
      </div>
      }
    </div>

    <div class="a-example-full-width-alterno-content" style="margin-top: 2%">
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
        @if (config.mostrarBotonGuardarPlantilla) {
        <p-button label="GUARDAR PLANTILLA" icon="pi pi-save" (onClick)="guardarPlantilla()" class="guardar-button"
          [disabled]="!correoValid() || config.modoLectura">
        </p-button>
        }

        <p-button label="ENVIAR CORREO" icon="pi pi-send" (onClick)="enviarCorreo()" class="guardar-button"
          [disabled]="!correoValid()">
        </p-button>

        <p-button label="SALIR" icon="pi pi-times" class="p-button-secondary" (onClick)="salir()">
        </p-button>
      </div>
    </div>
  </form>
</div>

<p-confirmDialog></p-confirmDialog>